<div class="news-container" *ngIf="news">
  <app-mobile-header [title]="channelSecData?.data?.sectionDesc ?? 'news.header'" [manualBackEvent]="true"
    (onManualBackEvent)="onClickBack()"></app-mobile-header>

  <ng-template [ngIf]="formatedDataSet && formatedDataSet.length > 0">
    <div class="news-card" *ngFor="let itm of formatedDataSet; let last = last" (click)="onClickCard(itm.infoUrl)"
      [ngStyle]="{'padding-bottom': last ? '0' : '40px'}">
      <div class="news-image">
        <img *ngIf="itm && itm.imgUrlObj.sectionCode === '201'" [src]="itm.imgUrlObj.sectionData"
          [alt]="itm.titleObj.sectionData" loading="lazy" />
      </div>
      <div class="news-desc">
        <h1 *ngIf="itm && itm.titleObj.sectionCode === '101'" class="title">{{itm.titleObj.sectionData}}</h1>
        <h1 *ngIf="itm && itm.subtitleObj.sectionCode === '102'" class="sub-title">{{itm.subtitleObj.sectionData}}
        </h1>
      </div>
    </div>

    <div class="news-end-scroll">{{'desc.end.scroll' | translate}}</div>
  </ng-template>

  <ng-template [ngIf]="!formatedDataSet || formatedDataSet.length == 0">
    <div class="no-news-container">
      <img src="assets/generalImage/empty.svg" alt="mascot" />
      <h1>{{'no.news.for.now' | translate}}</h1>
      <app-button [buttonName]="'button.back.to.home' | translate" (onClickEvent)="onClickBack()"
        class="back-btn"></app-button>
    </div>
  </ng-template>
</div>
